import { Link } from "@mui/material";
import * as React from "react";

import { useNavigation } from "@/providers";
import { AssociationRecord } from "@/shared/domain/association";
import { MessagePathRecord, TopicRecord } from "@/shared/domain/topics";
import { getWorkspaceInput } from "@/shared/domain/workspaces/WorkspaceBuilder";
import { determineDefaultPanelType } from "@/shared/state/visualization/schema/v1";

interface MessagePathLinkProps {
  messagePath: MessagePathRecord;
  topic: TopicRecord;
  topicAssociation: AssociationRecord;
  linkPrefix?: string;
  className?: string;

  /**
   * If provided, the file will be opened at the given time.
   * Otherwise, the file will be opened at the start of the file.
   *
   * `startTime` is in nanoseconds since the UNIX epoch.
   **/
  startTime?: bigint;
}

export const MessagePathLink: React.FC<MessagePathLinkProps> = ({
  messagePath,
  topic,
  topicAssociation,
  linkPrefix,
  className,
  startTime,
}) => {
  const { goto } = useNavigation();

  const handleClick = () => {
    const panelType = determineDefaultPanelType(
      messagePath.canonical_data_type,
    );

    goto.visualize({
      dataSource: {
        files: [topicAssociation.association_id],
      },
      params: {
        layout: getWorkspaceInput(panelType, topic, messagePath),
        t: startTime,
      },
    });
  };

  return (
    <Link
      onClick={handleClick}
      component="button"
      underline="hover"
      variant="body2"
      className={className}
      sx={{ userSelect: "text" }}
    >
      {linkPrefix}
      {messagePath.message_path}
    </Link>
  );
};
